import { render, staticRenderFns } from "./Scrollable.vue?vue&type=template&id=3449c5aa&"
import script from "./Scrollable.vue?vue&type=script&lang=ts&"
export * from "./Scrollable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports